import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";

const BusinessStatusContext = createContext(null);

export const BusinessStatusProvider = ({ children }) => {
  const [status, setStatus] = useState(null);

  const refresh = useCallback(() => {
    api.get("/business-status").then((r) => setStatus(r.data)).catch((e) => console.warn("business status refresh failed", e));
  }, []);

  useEffect(() => {
    refresh();
    const iv = setInterval(refresh, 60000);
    const onFocus = () => refresh();
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onFocus);
    return () => {
      clearInterval(iv);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onFocus);
    };
  }, [refresh]);

  const value = useMemo(() => ({ status, refresh }), [status, refresh]);

  return <BusinessStatusContext.Provider value={value}>{children}</BusinessStatusContext.Provider>;
};

export const useBusinessStatus = () => useContext(BusinessStatusContext);
